var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 58"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#7B4EF8",
    clipPath: "url(#sort_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.667.5h7.25a9.167 9.167 0 0 1 9.166 9.167v7.25a9.167 9.167 0 0 1-9.166 9.166h-7.25A9.167 9.167 0 0 1 .5 16.917v-7.25A9.167 9.167 0 0 1 9.667.5ZM9.667 31.61h7.25a9.167 9.167 0 0 1 9.166 9.166v7.25a9.167 9.167 0 0 1-9.166 9.167h-7.25A9.167 9.167 0 0 1 .5 48.026v-7.25a9.167 9.167 0 0 1 9.167-9.167ZM45.875 1.563V55.99"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m35.898 11.047 9.997-9.996 9.996 9.996M55.89 46.906l-9.996 9.997-9.996-9.997"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sort_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h58v58H0z"
  })))));
};
export default SvgSort;